<script setup>
import { ref } from 'vue';
const competitionData = ref(null);
</script>

<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.MATCH.SHOW_COMPETITION_DETAIL"
    :handler="
      (data) => {
        competitionData = data;
        $refs.dialog.show();
      }
    "
  />
  <DialogComponent
    ref="dialog"
    type="fullscreen"
    hideCloseButton
    noInnerPadding
  >
    <div
      class="h-full pb-[5vh] overflow-auto w-full top-0 left-0 pt-24"
      v-if="competitionData"
    >
      <div class="bg-primary fixed top-0 w-full">
        <div class="mobile-status-padding"></div>
        <div class="px-4 overflow-x-hidden w-full h-24">
          <div class="flex gap-4 items-center h-full">
            <div class="w-8 h-8 min-w-8 flex items-center justify-center">
              <button class="w-full h-full" @click="$refs.dialog.hide()">
                <ColorImg
                  src="/images/icons/arrow-up.svg"
                  class="w-full h-full bg-white -rotate-90 opacity-70"
                  alt="Calendar"
                />
              </button>
            </div>
            <div class="w-full overflow-hidden">
              <div
                class="text-white truncate w-full text-center text-2xl uppercase font-bold"
              >
                {{ competitionData?.category?.name || '-' }}
              </div>
            </div>
            <div class="w-8 h-8 min-w-8 flex items-center justify-center"></div>
          </div>
        </div>
      </div>
      <div class="mobile-status-padding"></div>

      <div class="p-8">
        <div class="text-xl text-primary-900 font-bold mb-2">Calendirer</div>
        <div class="flex gap-5 flex-col divide-gray-200">
          <MatchesPresentation
            v-for="(match, matchIndex) in competitionData.matches"
            :key="matchIndex"
            :match="match"
            class="rounded-xl bg-white"
            @click="
              $bus.emit($constants.EVENTS.MATCH.SHOW_MATCH_DETAIL, match)
            "
          />
        </div>
      </div>
    </div>
  </DialogComponent>
</template>
